import { createStore } from "redux";
import { v4 as uuidv4 } from "uuid";

const initialState = {
    order: {
        id: uuidv4(),
        created_at: new Date(),
        total: 0,
        products: [],
        people: [],
    },
    settings: {
        darkMode: false,
        notifications: true,
        changes: false,
    },
    feedback: [],
    showedPromotion: false,
    menuType: "MENU"
};

function saveToLocalStorage(state) {
    try {
        const serializedSate = JSON.stringify(state);
        // eslint-disable-next-line no-undef
        localStorage.setItem("state", serializedSate);
    } catch (e) {
        return null;
    }
}

function loadFromLocalStorage() {
    try {
        // eslint-disable-next-line no-undef
        const serializedSate = localStorage.getItem("state");
        if (serializedSate === null) return undefined;
        let savedState = JSON.parse(serializedSate);
        savedState["feedback"] = [];
        savedState["showedPromotion"] = false;
        return savedState;
    } catch (e) {
        return undefined;
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "FEEDBACK":
            return {
                ...state,
                feedback: state.feedback ? [...state.feedback, action.data] : [action.data],
            };
            case "MENU_TYPE":
                return {
                    ...state,
                    menuType: action.data,
                };
        case "SHOWED_PROMOTION":
            return {
                ...state,
                showedPromotion: true,
            };
        case "ORDER":
            return {
                ...state,
                order: action.data,
                suggested: null,
            };
        case "CLEAN_ORDER":
            return {
                ...state,
                order: {
                    id: uuidv4(),
                    created_at: new Date(),
                    total: 0,
                    products: [],
                    people: [],
                },
            };
        case "ADD_REMOVE_PRODUCTS":
            return {
                ...state,
                order: {
                    ...state.order,
                    products: action.data.products,
                    total: action.data.total,
                },
            };
        case "ITEM_SUGGESTED":
            return {
                ...state,
                suggested: action.data,
            };
        case "DARK_MODE":
            return {
                ...state,
                settings: {
                    ...state.settings,
                    darkMode: action.data.darkMode,
                    changes: action.data.changes,
                },
            };
        case "LANGUAGE":
            return {
                ...state,
                settings: {
                    ...state.settings,
                    language: action.data,
                },
            };
        case "NOTIFICATION":
            return {
                ...state,
                settings: {
                    ...state.settings,
                    notifications: action.data,
                },
            };
        default:
            return state;
    }
};

const persistedState = loadFromLocalStorage();

const store = createStore(reducer, persistedState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

store.subscribe(() => saveToLocalStorage(store.getState()));

export default store;
